import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=1f3a8fa8&"
import script from "./FaqCategory.vue?vue&type=script&lang=js&"
export * from "./FaqCategory.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=1f3a8fa8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports